import type { Emitter } from 'mitt';
import mitt, { EventType } from "mitt";

const TRACK_COMPLETE_RATE_EVENT = Symbol('TRACK_COMPLETE_RATE_EVENT');

type Action = 'save' | 'publish' | 'schedule';
interface GemMeterEvent extends Record<EventType, unknown> {
    [TRACK_COMPLETE_RATE_EVENT]: Action
}

const emitter: Emitter<GemMeterEvent> = mitt<GemMeterEvent>();

export function emitTrackCompleteRateEvent(action: Action) {
    emitter.emit(TRACK_COMPLETE_RATE_EVENT, action);
}

export function onTrackCompleteRateEvent(callback: (action: Action) => void) {
    emitter.on(TRACK_COMPLETE_RATE_EVENT, (action) => {
        callback(action);
    });
}

export function offTrackCompleteRateEvent() {
    emitter.off(TRACK_COMPLETE_RATE_EVENT);
}
